/* =====================================================================================================================
   MJP GIFT CARD - scheda prodotto (sections/mjp-giftcard-product.liquid)
   Taglio scelto -> importo sulla carta, riepilogo carta + cofanetto, id del modulo. Carrello con /cart/add.js SENZA
   proprieta' di riga (patto ERP). Senza JavaScript il modulo invia comunque il primo taglio disponibile.
   ===================================================================================================================== */
(function () {
  'use strict';
  if (window.__mgcPdp) return;
  window.__mgcPdp = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    var d = document.querySelector('cart-drawer');
    setTimeout(function () {
      if (d && typeof d.show === 'function') d.show();
      else document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: {} }));
    }, 120);
  }

  function init(root) {
    if (root.dataset.mgcBound) return;
    root.dataset.mgcBound = '1';
    var vs = [];
    try { vs = JSON.parse(qs(root, '[data-mgc-variants]').textContent); } catch (e) { vs = []; }
    var form = qs(root, '[data-mgc-form]'), idInput = qs(root, '[data-mgc-id]'), pills = qsa(root, '.mgc-pill');
    var addBtn = qs(root, '[data-mgc-add]'), label = addBtn && qs(addBtn, '[data-label]'), labelDefault = label ? label.textContent : '';
    var msg = qs(root, '[data-mgc-msg]'), qty = qs(root, '[data-mgc-qty-input]');
    var chip = qs(root, '[data-mgc-chip]'), totalEl = qs(root, '.mgc-sum__total [data-mgc-price]'), raf = null, curCents = null;
    var T = { added: root.dataset.tAdded || 'Aggiunto al carrello', error: root.dataset.tError || 'Non è stato possibile aggiungere. Riprova.' };

    function find(id) { for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i]; return null; }
    function text(sel, val) { qsa(root, sel).forEach(function (el) { el.textContent = val; }); }
    function show(sel, on) { qsa(root, sel).forEach(function (el) { el.hidden = !on; }); }

    /* Il totale scorre dal prezzo precedente al nuovo; alla fine si scrive il testo esatto di Shopify */
    function rollTotal(v) {
      if (!totalEl) return;
      if (typeof v.pc !== 'number') { totalEl.textContent = v.price; return; }
      var from = curCents == null ? v.pc : curCents, to = v.pc; curCents = to;
      if (raf) cancelAnimationFrame(raf);
      if (REDUCED || from === to) { totalEl.textContent = v.price; return; }
      var t0 = null, dur = 480;
      function fmt(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        totalEl.textContent = p < 1 ? fmt(Math.round(from + (to - from) * e)) : v.price;
        raf = p < 1 ? requestAnimationFrame(step) : null;
      }
      raf = requestAnimationFrame(step);
    }

    /* Selettore del taglio (patto v3, 28 tagli): importo grande, - / +, cursore a passi, scorciatoie */
    var range = qs(root, '[data-mgc-range]'), amtVal = qs(root, '[data-mgc-amt-val]');
    function idxOf(v) { return vs.indexOf(v); }
    function paintRange(i) {
      if (!range) return;
      range.value = i;
      var max = parseInt(range.max, 10) || 1;
      range.style.setProperty('--p', (i / max * 100) + '%');
    }

    function select(v) {
      if (!v) return;
      idInput.value = v.id;
      pills.forEach(function (p) { var on = parseInt(p.dataset.id, 10) === v.id; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); });
      paintRange(idxOf(v));
      if (amtVal) {
        amtVal.textContent = v.card || v.label;
        amtVal.classList.toggle('is-off', !v.a);
        if (!REDUCED) { amtVal.classList.remove('is-bump'); void amtVal.offsetWidth; amtVal.classList.add('is-bump'); }
      }
      qsa(root, '[data-mgc-price]').forEach(function (el) { if (el !== totalEl) el.textContent = v.price; });
      rollTotal(v);
      text('[data-mgc-sticky-price]', v.price);
      text('[data-mgc-card]', v.card);
      text('[data-mgc-fee]', v.fee);
      show('[data-mgc-row-card]', !!v.card);
      show('[data-mgc-row-fee]', !!v.fee);
      if (chip && v.card && chip.textContent !== v.card) {
        chip.textContent = v.card;
        if (!REDUCED) { chip.classList.remove('is-bump'); void chip.offsetWidth; chip.classList.add('is-bump'); }
      }
      if (addBtn) { addBtn.disabled = !v.a; if (label) label.textContent = labelDefault; }
      if (msg) msg.hidden = true;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () { if (!p.disabled) select(find(parseInt(p.dataset.id, 10))); });
    });
    if (range) range.addEventListener('input', function () { select(vs[parseInt(range.value, 10)] || null); });
    qsa(root, '[data-mgc-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = find(parseInt(idInput.value, 10)), i = idxOf(cur) + parseInt(b.dataset.mgcStep, 10);
        if (i >= 0 && i < vs.length) select(vs[i]);
      });
    });
    var cur0 = find(parseInt(idInput.value, 10)); if (cur0) paintRange(idxOf(cur0));
    /* Frecce tra i tagli (gruppo radio) */
    var group = qs(root, '[data-mgc-pills]');
    if (group) group.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
      var on = pills.filter(function (p) { return !p.disabled; }), i = on.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = on[(i + ((e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1) + on.length) % on.length];
      n.focus(); n.click();
    });

    qsa(root, '[data-mgc-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.mgcQty, 10);
        qty.value = Math.min(Math.max(n, 1), parseInt(qty.max, 10) || 20);
      });
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;
      addBtn.disabled = true;
      var item = { id: parseInt(idInput.value, 10), quantity: Math.max(1, parseInt(qty.value, 10) || 1) };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || ''); return d; }); })
        .then(function () {
          addBtn.classList.add('is-done'); if (label) label.textContent = T.added;
          openDrawer();
          setTimeout(function () { addBtn.classList.remove('is-done'); if (label) label.textContent = labelDefault; addBtn.disabled = false; }, 1800);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          if (msg) { msg.textContent = (err && err.message) || T.error; msg.hidden = false; }
        });
    });

    /* ---------- Galleria: solo le foto dell'inserzione ---------- */
    var gal = qs(root, '[data-mgc-gal]');
    if (gal) {
      var track = qs(gal, '[data-mgc-track]'), slides = qsa(gal, '[data-mgc-slide]'), thumbs = qsa(root, '[data-mgc-go]');
      var idxEl = qs(gal, '[data-mgc-idx]'), bar = qs(gal, '[data-mgc-progress]'), n = slides.length, cur = 0;
      var mobile = window.matchMedia('(max-width: 899px)');
      var paint = function (i) {
        cur = i;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        if (idxEl) idxEl.textContent = i + 1;
        if (bar && n) bar.style.left = (i * 100 / n) + '%';
      };
      var go = function (i) {
        if (!n) return;
        i = (i + n) % n;
        if (mobile.matches) track.scrollTo({ left: i * track.clientWidth, behavior: REDUCED ? 'auto' : 'smooth' });
        gal.classList.remove('is-zoom');
        paint(i);
      };
      qsa(gal, '[data-mgc-nav]').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.dataset.mgcNav, 10)); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.mgcGo, 10)); }); });
      if (n > 1) {
        gal.setAttribute('tabindex', '0');
        gal.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
      }
      /* Mobile: lo scorrimento col dito aggiorna contatore e barra */
      var st = null;
      track.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        clearTimeout(st);
        st = setTimeout(function () { paint(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
      }, { passive: true });
      /* Desktop: clic per ingrandire, l'ingrandimento segue il mouse */
      if (!REDUCED && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        track.addEventListener('click', function () { if (!mobile.matches && n) gal.classList.toggle('is-zoom'); });
        track.addEventListener('mousemove', function (e) {
          var img = slides[cur] && qs(slides[cur], '.mgc-gal__img'); if (!img) return;
          var r = track.getBoundingClientRect();
          img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
        track.addEventListener('mouseleave', function () { gal.classList.remove('is-zoom'); });
      }
    }

    /* Comparsa allo scorrimento */
    /* "Acquistando la gift card accetti le Condizioni d'uso": il link apre la sezione e ci porta */
    var termsLink = qs(root, '[data-mgc-terms-link]'), terms = qs(root, '[data-mgc-terms]');
    if (termsLink && terms) termsLink.addEventListener('click', function (e) {
      e.preventDefault();
      terms.open = true;
      terms.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var rev = qsa(root, '[data-mgc-reveal]');
    if (!('IntersectionObserver' in window) || REDUCED) rev.forEach(function (el) { el.classList.add('is-in'); });
    else {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -6% 0px' });
      rev.forEach(function (el) { io.observe(el); });
    }

    /* Barra fissa su mobile quando il pulsante principale non si vede */
    var sticky = qs(root, '[data-mgc-sticky]'), stickyAdd = qs(root, '[data-mgc-sticky-add]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = on ? 0 : -1;
      }).observe(addBtn);
      if (stickyAdd) stickyAdd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    }
  }

  function boot() { qsa(document, '[data-mgc-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-mgc-pdp]');
    if (r) init(r);
  });
})();
